'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  menu = [{
    title: 'Home',
    state: 'main'
  }];

  isCollapsed = true;

  constructor(Auth, $window, $scope, $attrs,$element) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isGroupAdmin = Auth.isGroupAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$window = $window;
    this.$scope = $scope;
    this.$attrs = $attrs;
    this.$element = $element;
  }

  $onInit() {
    let myWindow = angular.element(this.$window);

    let offsetTop = this.$element.offset().top; // get element's top relative to the document
    console.log(this.$element.children());

    myWindow.on('scroll',  (e) => {
      if (myWindow.scrollTop() >= 80) {
        this.$element.children().addClass('fix-to-top');
      } else {
        this.$element.children().removeClass('fix-to-top');
      }
    });
  }

}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js